// extracted by mini-css-extract-plugin
module.exports = {"keyTemplatesItem":"styles_keyTemplatesItem__YU2HY"};